import { PaymentProviders } from './PaymentProviders';
import { PaymentProvider } from './PaymentProvider';

export class RedepagosProvider extends PaymentProvider {
    constructor() {
        super(PaymentProviders.Redepagos);
    }
}
